function backendErrorParserService () {
  var BACKEND_ERROR_CODES = {
    USER_INACTIVE: 'USER_INACTIVE',
    USER_PENDING: 'USER_PENDING',
    APPLICATION_ERROR: 'APPLICATION_ERROR',
    AUTHORIZATION_ERROR: 'AUTHORIZATION_ERROR',
    BAD_REQUEST_ERROR: 'BAD_REQUEST_ERROR',
    REQUEST_CONFLICT: 'REQUEST_CONFLICT',
    NOT_FOUND: 'NOT_FOUND',
    WRONG_PASSWORD: 'WRONG_PASSWORD',
    WRONG_EMAIL_PASSWORD: 'WRONG_EMAIL_PASSWORD',
    LOGIN_WITH_SSO: 'LOGIN_WITH_SSO',
    LOGIN_WITH_MFA: 'LOGIN_WITH_MFA',
    STRONG_PASSWORD: 'STRONG_PASSWORD',
    EXPIRED_PASSWORD: 'EXPIRED_PASSWORD',
    PASSWORD_ALREADY_USED: 'PASSWORD_ALREADY_USED',
    INVALID_FILE: 'INVALID_FILE',
    BLOCK_LOGINS: 'BLOCK_LOGINS'
  }
  Object.freeze(BACKEND_ERROR_CODES)

  function _getBackendErrorType (oError) {
    var sErrorType = ''
    if (oError && oError.data && oError.data.code) {
      sErrorType = oError.data.code
    }
    return sErrorType
  }

  function BackendErrorParserService () {}

  BackendErrorParserService.prototype.isUserInactiveError = function (oError) {
    return _getBackendErrorType(oError) === BACKEND_ERROR_CODES.USER_INACTIVE
  }

  BackendErrorParserService.prototype.isUserPendingError = function (oError) {
    return _getBackendErrorType(oError) === BACKEND_ERROR_CODES.USER_PENDING
  }

  BackendErrorParserService.prototype.isApplicationError = function (oError) {
    return _getBackendErrorType(oError) === BACKEND_ERROR_CODES.APPLICATION_ERROR
  }

  BackendErrorParserService.prototype.isAuthorizationError = function (oError) {
    return _getBackendErrorType(oError) === BACKEND_ERROR_CODES.AUTHORIZATION_ERROR
  }

  BackendErrorParserService.prototype.isBadRequestError = function (oError) {
    return _getBackendErrorType(oError) === BACKEND_ERROR_CODES.BAD_REQUEST_ERROR
  }

  BackendErrorParserService.prototype.isRequestConflictError = function (oError) {
    return _getBackendErrorType(oError) === BACKEND_ERROR_CODES.REQUEST_CONFLICT
  }

  BackendErrorParserService.prototype.isNotFoundError = function (oError) {
    return _getBackendErrorType(oError) === BACKEND_ERROR_CODES.NOT_FOUND
  }

  BackendErrorParserService.prototype.isWrongPassword = function (oError) {
    return _getBackendErrorType(oError) === BACKEND_ERROR_CODES.WRONG_PASSWORD
  }

  BackendErrorParserService.prototype.isWrongPasswordOrEmail = function (oError) {
    return _getBackendErrorType(oError) === BACKEND_ERROR_CODES.WRONG_EMAIL_PASSWORD
  }

  BackendErrorParserService.prototype.shouldLoginWithSSO = function (error) {
    return _getBackendErrorType(error) === BACKEND_ERROR_CODES.LOGIN_WITH_SSO
  }

  BackendErrorParserService.prototype.isRateLimitError = function (error) {
    return error.status === 429
  }

  BackendErrorParserService.prototype.shouldLoginWithMFA = function (error) {
    return _getBackendErrorType(error) === BACKEND_ERROR_CODES.LOGIN_WITH_MFA
  }

  BackendErrorParserService.prototype.shouldHaveStrongPassword = function (error) {
    return _getBackendErrorType(error) === BACKEND_ERROR_CODES.STRONG_PASSWORD
  }

  BackendErrorParserService.prototype.isPasswordExpired = function (error) {
    return _getBackendErrorType(error) === BACKEND_ERROR_CODES.EXPIRED_PASSWORD
  }

  BackendErrorParserService.prototype.passwordAlreadyUsed = function (error) {
    return _getBackendErrorType(error) === BACKEND_ERROR_CODES.PASSWORD_ALREADY_USED
  }

  BackendErrorParserService.prototype.isInvalidFileError = function (error) {
    return _getBackendErrorType(error) === BACKEND_ERROR_CODES.INVALID_FILE
  }

  BackendErrorParserService.prototype.isBlockLoginsError = function (error) {
    return _getBackendErrorType(error) === BACKEND_ERROR_CODES.BLOCK_LOGINS
  }

  return new BackendErrorParserService()
}

export { backendErrorParserService }
